import { render, staticRenderFns } from "./settingThirdPlatform.vue?vue&type=template&id=b8b3ecea&scoped=true"
import script from "./settingThirdPlatform.vue?vue&type=script&lang=js"
export * from "./settingThirdPlatform.vue?vue&type=script&lang=js"
import style0 from "./settingThirdPlatform.vue?vue&type=style&index=0&id=b8b3ecea&prod&lang=less&scoped=true"
import style1 from "./settingThirdPlatform.vue?vue&type=style&index=1&id=b8b3ecea&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b3ecea",
  null
  
)

export default component.exports